module.exports = __webpack_public_path__ + "img/everton.4aa2d082.png";